import { DbHelpers, DbType } from '@Utils/db-driver-helpers';
import { useEffect, useState } from 'react';

type DriverDetectorReturn = boolean;

export const useDriverDetector = (
	dependency: string,
	type: DbType,
): DriverDetectorReturn => {
	const [isDriverType, setIsDriverType] = useState(false);

	useEffect(() => {
		const isType = DbHelpers.isOfType(type, dependency);
		setIsDriverType(isType);
	}, [dependency]);

	return isDriverType;
};
